<div
  class="advanced-filter-group"
  [class.advanced-filter-group--top-level]="isTopLevelGroup"
  [class.advanced-filter-group--nested]="!isTopLevelGroup"
  [attr.data-depth]="depth % 3">

  <div class="group-header">
    <span class="group-header-label">{{ isTopLevelGroup ? 'Filter group' : 'Sub-group' }}</span>
    @if (filterGroup?.filtersAndGroups?.length > 1) {
      <div class="group-operator-toggle">
        <button
          type="button"
          class="operator-btn"
          [class.operator-btn--active]="filterGroup.operator === 'AND'"
          (click)="onToggleOperator('AND')">
          AND
        </button>
        <button
          type="button"
          class="operator-btn"
          [class.operator-btn--active]="filterGroup.operator === 'OR'"
          (click)="onToggleOperator('OR')">
          OR
        </button>
      </div>
    }
    @if ((!isTopLevelGroup) || (isTopLevelGroup && allowDeleteTopLevel)) {
      <app-shared-button (click)="onDeleteItemClick()" [fill]="false" [colour]="'clear'" class="group-delete-btn">
        <app-icon-delete-outline [tooltip]="isTopLevelGroup ? 'Delete Group' : 'Delete Sub-group'"></app-icon-delete-outline>
      </app-shared-button>
    }
  </div>

  @if (filterGroup?.filtersAndGroups?.length > 0) {
    <div class="advanced-filter-group-container">
      @for (group of filterGroup.filtersAndGroups; track group.id; let i = $index) {
        @if (i > 0) {
          <div class="group-connector">
            <span class="connector-line"></span>
            <span class="connector-operator-label">{{ filterGroup.operator }}</span>
            <span class="connector-line"></span>
          </div>
        }

        @if (!getObjectHasProperty(group, 'operator')) {
          <app-shared-modal-filters-advanced-group-item
            [allowRemove]="canRemoveCondition(group)"
            [setColDef]="colDefs"
            [setFilter]="group">
          </app-shared-modal-filters-advanced-group-item>
        } @else {
          <app-shared-modal-filters-advanced-group
            [depth]="depth + 1"
            [isTopLevelGroup]="false"
            [predecessorID]="group.id"
            [setColDef]="colDefs"
            [setFilterGroups]="group">
          </app-shared-modal-filters-advanced-group>
        }
      }
    </div>
  }

  <div class="af-add-buttons">
    <button type="button" class="af-text-btn" (click)="onAddFilterClick()">
      <app-icon-plus [tooltip]="'Add Filter'"></app-icon-plus>
      Add Condition
    </button>
    <span class="af-add-divider">|</span>
    <button type="button" class="af-text-btn" (click)="onAddGroupClick()">
      <app-icon-playlist-plus [tooltip]="'Add Group'"></app-icon-playlist-plus>
      Add Sub-group
    </button>
  </div>
</div>
